import { render, staticRenderFns } from "./Collect.vue?vue&type=template&id=0969ead0&scoped=true&"
import script from "./Collect.vue?vue&type=script&lang=ts&"
export * from "./Collect.vue?vue&type=script&lang=ts&"
import style0 from "./Collect.vue?vue&type=style&index=0&id=0969ead0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0969ead0",
  null
  
)

export default component.exports